

import { Component, Prop, Vue } from 'vue-property-decorator';
import { form19StatusInfoType } from '@/types/Information/Form19';

import StepNumber from "@/components/utils/StepNumber.vue";

@Component({
    components:{
        StepNumber
    }
})
export default class Form19ProcessHeader extends Vue {  
    
    @Prop({required: true})
    stepsCompleted!: form19StatusInfoType;

}
